
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/amc/my-devices",
      function () {
        return require("private-next-pages/amc/my-devices.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/amc/my-devices"])
      });
    }
  